var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVantagemCompetitiva(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vantagem-competitiva",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vantagem-competitiva_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,58.3c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12C44.6,53,50,58.3,56.6,58.3z M56.6,42.3 c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4s-4-1.8-4-4C52.6,44.1,54.4,42.3,56.6,42.3z M60.4,78.1h8v58.5h-8V78.1z M124.5,48.6l9.2-14.2 H98.8v27.8H48.9c-3.2,0-6.2,1.3-8.4,3.5c-2.2,2.3-3.4,5.3-3.4,8.4v33.6h7.6v29h8v-37H45V74.1c0-2.2,1.7-4,3.9-4h57.9v-7.8H134 L124.5,48.6z M118.8,54.3h-12v-12H119l-4.1,6.3L118.8,54.3z M98.6,78.1h8v58.5h-8V78.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVantagemCompetitiva);
export default __webpack_public_path__ + "static/media/vantagem-competitiva.440a17e0d4b7c750a116fa5b130ce13f.svg";
export { ForwardRef as ReactComponent };